export default __webpack_public_path__ + "static/media/travel.5fa98890.png";